// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "all-260114-0/static/css/" + chunkId + "." + "1f1f3bbb" + ".chunk.css";
};